import { useRef, type ReactNode } from 'react';
import { useDialogBehavior } from './Modal.tsx';

/**
 * Docked drawer for entity detail (screens, media). Open state is driven by the
 * URL by the caller, so drawers are deep-linkable (docs/06 UX #1). Right-docked
 * by default; `side="left"` docks it left (used for the mobile nav sheet). On
 * narrow viewports it expands to a full-width sheet (see app.css §mobile).
 */
export function Drawer({
  title,
  onClose,
  children,
  headerActions,
  side = 'right',
  className,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
  headerActions?: ReactNode;
  side?: 'left' | 'right';
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useDialogBehavior(true, onClose, ref);

  const cls = ['drawer', side === 'left' ? 'left' : '', className ?? ''].filter(Boolean).join(' ');

  return (
    <>
      <div className="drawer-overlay" onClick={onClose} />
      <div className={cls} role="dialog" aria-modal="true" aria-label={title} ref={ref} tabIndex={-1}>
        <div className="drawer-head">
          <h2>{title}</h2>
          <div className="row">
            {headerActions}
            <button className="close-x" aria-label="Close" onClick={onClose}>
              ×
            </button>
          </div>
        </div>
        <div className="drawer-body">{children}</div>
      </div>
    </>
  );
}
